import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getDataWithQueryString } from '../../../../api/componentAPIs';
import DeliveryProInfo from '../../Dispatch/RouteExecution/ProDetails/DeliveryProInfo';
import { withStyles } from '@material-ui/core';
import { withSnackbar } from 'notistack';
import { compose } from 'recompose';
import { getFormattedProDetails } from '../../Dispatch/RouteExecution/ProDetails/utils';
import { withUserProfile } from '../../../../userProfile/userProfileContext';

const styles = (theme) => ({
  proDetailsPanel: {
    position: 'absolute',
    left: 'auto'
  }
});

const ShowDeliveryProDetailsPopup = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const proId = props.proId;
  const [proDetails, setProDetails] = useState(null);
  useEffect(() => {
    const fetchProInfo = async () => {
      try {
        if (location.state?.data) {
          const { proId, driverRouteDetails, apiName, queryParams } = location.state?.data;
          setProDetails(null);
          const response = await getDataWithQueryString(apiName, queryParams);
          if (response?.status >= 200 && response?.status < 400) {
            const { data: responseData } = response;
            if (responseData) {
              const proDetails = getFormattedProDetails({
                stopData: responseData,
                proId,
                driverRouteDetails
              });
              setProDetails(proDetails);
            } else {
              handleError({ message: `Data not available for Pro: ${proId}` });
            }
          } else {
            handleError(response);
          }
        }
      } catch (error) {
        handleError(error);
      }
    };

    if (proId) {
      fetchProInfo();
    }
  }, [proId]);

  const handleError = (response) => {
    const errorMessage = response?.response?.data?.error?.message || response?.message;
    props.enqueueSnackbar(errorMessage || 'An error occurred while fetching Pro details', {
      variant: 'error'
    });
    handleClose();
  };

  const handleClose = () => {
    setProDetails(null);
    navigate(location.pathname, { replace: true });
  };
  return proId && proDetails ? (
    <DeliveryProInfo
      proDetails={proDetails}
      open={true}
      key={proDetails.proId}
      onClose={handleClose}
      customModalClasses={props.classes.proDetailsPanel}
      applyDrawerShadow
      freightBillDetailsApi={
        location.state?.data?.freightBillDetailsApiName || 'GetFreightBillDetails'
      }
      freightBillDetailsQueryParams={
        location.state?.data?.freightBillDetailsQueryParams ||
        `terminalCode=${props.userData.userProfile.terminal.code}&routeId=${proDetails.driverData.routeId}&shipmentId=${proDetails.proData.shipmentId}`
      }
      hideViewProImages={location.state?.data?.hideViewProImages}
      proImageApiName={location.state?.data?.proImageApiName}
    />
  ) : null;
};

export default compose(withStyles(styles), withSnackbar, withUserProfile)(ShowDeliveryProDetailsPopup);
